import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTenantFeatureFlags = (token, id = "", tenantId) => {
    return fetch(`${apiUrl}tenant_feature_flags/${id}${tenantId ? '?TenantID=' + tenantId : ''}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getTenantFeatureFlags